module.exports = __webpack_public_path__ + "static/img/04.30f8873.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/04.png
// module id = vZ3Z
// module chunks = 1